import axiosInstance from "./axiosInstance";
import { catchError } from "../utils/errorHandler";
import { Device } from "@twilio/voice-sdk";
import { message } from "antd";
const notificationsService = {
  getNotificationsList: async (
    level = "urgent",
    search = "",
    page = 1,
    pageSize = 50,
    unread = false,
    type,
  ) => {
    const query = new URLSearchParams({ level, page, page_size: pageSize });

    // Only add `search` if it's not empty
    if (search) {
      query.append("search", search);
    }
    if (unread) {
      query.append("unread", unread);
    }
    if (type) {
      query.append("type", type);
    }
    try {
      const response = await axiosInstance.get(
        `notifications/v2/list/?${query}`,
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return { success: false };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },

  markAsReadNotification: async (notificationIds) => {
    try {
      const uids = Array.isArray(notificationIds)
        ? notificationIds
        : [notificationIds];
      const response = await axiosInstance.post(
        `notifications/v2/mark-as-read/`,
        {
          uids,
        },
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return { success: false, message: "Failed to mark notification as read" };
    } catch (error) {
      await catchError(error);
      return {
        success: false,
        message: "An error occurred while marking notification as read",
      };
    }
  },
  markAsUnreadNotification: async (notificationIds) => {
    try {
      const uids = Array.isArray(notificationIds)
        ? notificationIds
        : [notificationIds];
      const response = await axiosInstance.post(
        `notifications/v2/mark-as-unread/`,
        {
          uids,
        },
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return { success: false, message: "Failed to mark notification as read" };
    } catch (error) {
      await catchError(error);
      return {
        success: false,
        message: "An error occurred while marking notification as read",
      };
    }
  },
};

export default notificationsService;
